import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import * as EmployeesAssetsReport from 'reports/components/employees_assets';
import * as Common from 'common/components';

class EmployeesAssetsReportView extends Component {
  static propTypes = {
    company: PropTypes.object.isRequired,
    subcompany: PropTypes.object.isRequired,
    count: PropTypes.number.isRequired,
    children: PropTypes.arrayOf(PropTypes.element),
    filters: PropTypes.shape({
      fulltext: PropTypes.string.isRequired,
    }).isRequired,
    pagination: PropTypes.shape({
      page: PropTypes.number.isRequired,
      limit: PropTypes.number.isRequired,
      totalPages: PropTypes.number.isRequired,
      orderBy: PropTypes.string.isRequired,
      order: PropTypes.string.isRequired,
    }).isRequired,
    isLoading: PropTypes.bool.isRequired,
    handleFiltersChange: PropTypes.func.isRequired,
    handleFiltersSubmit: PropTypes.func.isRequired,
    handleLimitChange: PropTypes.func.isRequired,
    handleOrderChange: PropTypes.func.isRequired,
    handlePageChange: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
  };

  render = () => (
    <Common.Wrapper fluid={true}>
      {/* <EmployeesAssetsReport.Header
        companyId={this.props.company.id}
        subcompanyId={this.props.subcompany.id}
        handleExport={this.props.handleExport}
      /> */}
      <div className="col-12">
        <Common.Portlet
          title={
            this.props.t('reports.title') + ' > ' + this.props.t('reports.employeesAssets.subtitle')
          }
          icon={'file-archive-o'}
          button={
            <EmployeesAssetsReport.Filters
              accounts={this.props.accounts}
              employees={this.props.employees}
              costCenters={this.props.costCenters}
              status={this.props.status}
              values={this.props.filters}
              handleValueChange={this.props.handleFiltersChange}
              handleSubmit={this.props.handleFiltersSubmit}
            />
          }
        >
          <div className="mb-2" style={{ position: 'relative' }}>
            <EmployeesAssetsReport.Table
              company={this.props.company}
              subcompany={this.props.subcompany}
              permissions={this.props.permissions}
              count={this.props.count}
              orderBy={this.props.pagination.orderBy}
              order={this.props.pagination.order}
              handleOrderChange={this.props.handleOrderChange}
            >
              {this.props.children}
            </EmployeesAssetsReport.Table>
            <Common.LoaderOverlay show={this.props.isLoading} />
          </div>
          <Common.Pagination
            {...this.props.pagination}
            handleLimitChange={this.props.handleLimitChange}
            handlePageChange={this.props.handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
}

export default translate()(EmployeesAssetsReportView);



// WEBPACK FOOTER //
// src/modules/secured/modules/reports/components/EmployeesAssetsReportView.js